export const SEARCH_REQUEST = '@search/SEARCH_REQUEST';
export const SEARCH_SUCCESS = '@search/SEARCH_SUCCESS';
export const SEARCH_FAILURE = '@search/SEARCH_FAILURE';

export const TOGGLE_SHOW = '@search/TOGGLE_SHOW';

export const SEARCH_CLEAR = '@search/SEARCH_CLEAR';
